<template>
  <v-container fluid class="language-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Language
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab
            class="mr-5"
            :href="`#tab-lists`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Translations
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Language</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'languagecode')"
                        v-bind:value="initvalue.languagecode"
                        placeholder="Language Code"
                        persistent-hint
                        single-line hint="Enter the language code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'languagename')"
                        v-bind:value="initvalue.languagename"
                        placeholder="Language Name"
                        persistent-hint
                        single-line hint="Enter the language name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'languageinfo')"
                        v-bind:value="initvalue.languageinfo"
                        placeholder="Language Info"
                        persistent-hint
                        single-line hint="Enter the language name info">
                      </v-text-field>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'languagestatus')"
                          v-bind:label="initvalue.languagestatus"
                          v-model="initvalue.languagestatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/language/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editLanguage()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/language/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-lists'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Translation List</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showAddListDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="listHeaders"
                        :items="languagelists"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteListDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this List? </v-card-title>
                              <v-card-text>
                                {{ deletelist.listtext }} {{ deletelist.listinfo }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteListDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteLanguageList(deletelist)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editLanguageListDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteLanguageListDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/language/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="showAddListDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="list.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="list.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="list.listinfo"
                  label="Info (translation)"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showAddListDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addLanguageList"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-row>
    <v-row>
      <v-bottom-sheet scrollable v-model="showEditListDialog" inset>
        <v-sheet class="text-center" height="250px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showEditListDialog = !showEditListDialog">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listrank')"
                  :value="editlist.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listtext')"
                  v-model="editlist.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listinfo')"
                  v-model="editlist.listinfo"
                  label="Info (translation)"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editLanguageList()"
          >
            Edit
          </v-btn>
              </v-col>
          </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      filename: null,
      language: {},
      list: {},
      detail: {},
      photo: {},
      initvalue: {},
      deletelist: {},
      editlist: {},
      
      listHeaders: [
        { text: "#", value: "listrank", width: "10px" },
        { text: "Text", value: "listtext" },
        { text: "Translation", value: "listinfo" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      
      showAddListDialog: false,
      showEditListDialog: false,
      deleteListDialog: false,
      
      imageurl: undefined,
      images: [],
      languagelists: [],
      upload: {},
      items: ['Language', 'Other Language'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Language', ['deleteLanguageListRequest', 
                                'insertLanguageListRequest', 
                                'updateLanguageRequest', 'updateLanguageListRequest','updateLanguageImageRequest', 
                                'getLanguagesRequest']),
    async addLanguageList() {
      this.showAddListDialog = false;
      this.list.languageid = this.initvalue._id;
      let result = await this.insertLanguageListRequest(this.list);
      this.languagelists.push(result);
      this.list = {};
    },
    deleteLanguageListDialog(item) {
      this.deleteListDialog = true;
      this.deletelist = {
        _id: item._id,
        listtext: item.listtext,
        listinfo: item.listinfo,
      };
    },
    async deleteLanguageList(payload) {
      this.deleteListDialog = false;
      let response = await this.deleteLanguageListRequest(payload);
      let index = this.languagelists.findIndex((item) => item._id == response._id);
      this.languagelists.splice(index, 1);
    },
    editLanguageListDialog(item) {
      this.list = {};
      this.showEditListDialog = true;
      this.editlist = Object.assign({}, item);
    },
    async editLanguageList() {
      this.showEditListDialog = false;
      this.list.languagelistid = this.editlist._id;
      console.log(this.list)
      let response = await this.updateLanguageListRequest(this.list);
      let index = this.languagelists.findIndex((item) => item._id == response._id);
      this.languagelists.splice(index, 1, response);
    },
    async editLanguage() {
      this.language._id = this.initvalue._id;
      await this.updateLanguageRequest(this.language);
      router.push('/language/list');
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      await this.updateLanguageImageRequest(this.photo);
      router.push('/language/list');
    },
    updateChangedValue(value, field){
      this.language[field] = value;
    },
    updateChangedList(value, field){
      this.list[field] = value;
    },  
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.languageimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.languageimage = file;
      this.upload.imagename = file.name;
      console.log(this.upload);
    },
    uploadPhotos() {
      if(this.filename == null) return; 
      this.upload._id = this.initvalue._id;
      this.uploadItemImages(this.upload);
    },
    deletePhotos(imageurl) {
      console.log(imageurl);
      let del = {
        languageimage: imageurl,
        _id: this.initvalue._id,
      }
      this.deleteItemImages(del);
    },
    deleteItemImages(payload) {
      console.log(payload);
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      var url = 'https://api.accountxc.com:3100/delete/language/images/' + id;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var del = {
        method: "delete",
        url: url,
        headers: header,
        data: payload,
      };

      axios(del)
      .then( (response)=> {
        this.images = response.data.languageimages;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    uploadItemImages(payload) {
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];   
      var url = 'https://api.accountxc.com:3100/add/language/images/' + id;
      data = new FormData();
      data.append('image', payload.languageimage, payload.imagename); 
      delete payload['languageimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then( (response)=> {
        this.images = response.data.languageimages;
        this.filename = null;
      })
      .catch((error) => {
        console.error('Error:', error);
        this.filename = null;
      });
    },
  },
  computed: {
    ...mapState('Language', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.languageimage;
    this.languagelists = this.initvalue.languagelists;
    if(!this.initvalue._id) this.$router.push({ name: 'LanguageList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
